/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ScenarioVideoWithUrlAllOfPerformerTemplate } from './scenarioVideoWithUrlAllOfPerformerTemplate'
import type { ScenarioVideoWithUrlAllOfPerformerTemplate2 } from './scenarioVideoWithUrlAllOfPerformerTemplate2'
import type { ScenarioVideoWithUrlAllOfVideoTextTemplate } from './scenarioVideoWithUrlAllOfVideoTextTemplate'
import type { ScenarioVideoWithUrlAllOfVideoTextTemplate2 } from './scenarioVideoWithUrlAllOfVideoTextTemplate2'
import type { VideoTag } from './videoTag'

export type ScenarioVideoWithUrlAllOf = {
  /** @nullable */
  videoTextTemplate2: ScenarioVideoWithUrlAllOfVideoTextTemplate2
  /** @nullable */
  performerTemplate2: ScenarioVideoWithUrlAllOfPerformerTemplate2
  /** @nullable */
  videoTextTemplate: ScenarioVideoWithUrlAllOfVideoTextTemplate
  /** @nullable */
  performerTemplate: ScenarioVideoWithUrlAllOfPerformerTemplate
  videoTags: VideoTag[]
  /** @nullable */
  animatedThumbnailUrl: string | null
  /** @nullable */
  thumbnailUrl: string | null
  /**
   * HLS マスタープレイリストの未署名URL。hlsStatus=READY のときのみ。null なら MP4(url) で再生
   * @nullable
   */
  hlsUrl: string | null
  url: string
}
